




































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dealTypeMap, currencyMap, dateString, fmvAdjustHistoryColumns } from '@/utils/finance';
import { dealInvest, sliceDealInvest, fundListCommon } from '@/api/finance.js';
// import { roundSimpleList } from '@/api/common';
import roundSelect from '@/components/base/roundSelect.vue';

import moment from 'moment';

let validNum = (rule, val, cb) => {
  if (!val || /^\d+\.?\d*$/.test(`${val}`)) {
    cb();
  } else {
    cb(new Error('请输入合法数字'));
  }
};

let rules = {
  dealType: [{ required: true, message: '请选择本轮交易类型', trigger: 'blur' }],
  thisClassOfShareId: [{ required: true, message: '请选择企业所处轮次', trigger: 'blur' }],

  deliveryDate: [{ required: true, message: '请选择财务交割日期', trigger: 'change' }],
  effectDate: [{ required: true, message: '请选择生效时间', trigger: 'change' }],
  fundId: [{ required: true, message: '直接交易主体', trigger: 'blur' }],
  classOfShareId: [{ required: true, message: '请选择本轮交易轮次', trigger: 'blur' }],
  currency: [{ required: true, message: '请选择投资币种', trigger: 'blur' }],
  otherInvestors: [{ required: true, message: '请选择本轮其他投资人', trigger: 'blur' }],
  amount: [
    { required: true, message: '请填写实际投资金额', trigger: 'blur' }
    // { validator: validNum, trigger: 'blur' }
  ],
  shareNum: [
    { required: true, message: '请填写本轮持有股数', trigger: 'blur' }
    // { validator: validNum, trigger: 'blur' }
  ],
  totalShareNum: [
    { required: true, message: '请填写企业总股数', trigger: 'blur' }
    // { validator: validNum, trigger: 'blur' }
  ],
  preValuation: [
    { required: true, message: '请填写投前估值', trigger: 'blur' }
    // { validator: validNum, trigger: 'blur' }
  ],
  postValuation: [
    { required: true, message: '请填写投后估值', trigger: 'blur' }
    // { validator: validNum, trigger: 'blur' }
  ],
  shareUnitPrice: [
    { required: true, message: '请填写估值每股单价', trigger: 'blur' }
    // { validator: validNum, trigger: 'blur' }
  ],
  valuationCurrency: [{ required: true, message: '请选择估值币种', trigger: 'blur' }],
  bookRate: [{ required: true, message: '请填写汇率', trigger: 'blur' }]
};
@Component({
  components: { roundSelect }
})
class DealConfig extends Vue {
  classList: any[] = [];
  form: any = {};
  editType: number | null = null; // 1.新建 2.编辑
  inited: boolean = false;
  dealTypeMap = dealTypeMap;
  dealTypeList = [1, 2,11, 41, 42, 43].map(key => ({ value: +key, name: dealTypeMap[key] }));
  currencyMap = currencyMap;
  totalClassList: any[] = [];
  projectId: number | null = null;
  fundList: any[] = [];
  editDealData: any = {};
  investEventTrades: any[] = [];
  id: any = null;
  type: any = 'detail';

  // Seed、Venture、Growth、总部
  buMap = {
    Seed: 'Seed',
    Venture: 'Venture',
    Growth: 'Growth',
    总部: '总部'
  };

  rules: any = {
    dealType: rules.dealType
  };

  layout1 = { labelCol: { span: 5 }, wrapperCol: { span: 18 } };
  layout2 = { labelCol: { span: 20 }, wrapperCol: { span: 19 } };
  layout3 = { labelCol: { span: 20 }, wrapperCol: { span: 19 } };
  layout4 = { labelCol: { span: 20 }, wrapperCol: { span: 21 } };
  filterFundList = [];

  columnsCanEdit: any[] = [
    'eventClassOfShareId',
    'eventNature',
    'eventFundId',
    'eventCurrency',
    'eventAmount',
    'eventShareNum',
    'eventTotalShareNum',
    'eventTotalShareRatio',
    'eventUnitPriceText'
  ];
  eventDesMap: any = {
    eventTypeText: '事件类型',
    eventHappenDateText: '事件发生时间',
    eventEffectDateText: '生效时间',
    eventDescription: '事件原因及过程简要描述',
    eventClassOfShareName: '事件发生后轮次',
    eventNature: '事件发生后股票性质',
    eventFundText: '事件发生后本轮交易主体',
    // eventCurrency: '事件发生后本轮计量币种',
    eventCurrencyText: '事件发生后本轮计量币种',
    eventAmount: '事件发生后本轮持有部分成本',
    eventShareNum: '事件发生后本轮持有股数',
    // eventTotalShareNum: '企业总股数',
    eventTotalShareRatio: '事件发生后本轮持有股比',
    eventUnitPrice: '事件发生后本轮每股单价'
  };

  fundTypeNow: any = null;
  isDealChange: boolean = false;

  fmvAdjustHistoryData = [];
  fmvAdjustHistoryColumns = fmvAdjustHistoryColumns;

  @Prop()
  visible;

  get detail() {
    return this.type === 'slice' ? this.$store.state.middlePageSlice.detail : this.$store.state.middlePageDetail.detail;
  }

  get title() {
    if (this.type === 'slice') {
      return this.editType === 1 ? '新建交易切片' : '编辑交易切片';
    } else {
      return this.editType === 1 ? '新建交易' : '编辑交易';
    }
  }

  get dealList() {
    // 需要过滤掉dealType[5-IPO][6-重组][7-其他事件]产生的交易
    return this.$store.state.middlePageDetail.invest
      .filter(_ => [1, 2,11, 41, 42, 43].indexOf(_.dealType) > -1)
      .map(_ => {
        return {
          label: `${_.dealId}${_.classOfShare ? '-' + _.classOfShare : ''}-${_.deliveryDate}-${_.fund.name}`,
          id: _.dealId
        };
      });
  }

  async created() {
    // this.getRoundList();
    let { projectId, id, type } = this.$route.query;
    this.projectId = +projectId;
    this.id = id;
    this.type = type;
    await this.fetchDetail();
    this.editType = id ? 2 : 1;
    if (this.editType === 2) {
      this.dealTypeList = [1, 2, 11, 41, 42, 43, 5, 6, 7].map(key => ({ value: +key, name: dealTypeMap[key] }));
    }
    let { deliveryDate, fund = {}, bookRate, shareUnitPrice = '', effectDate, dealId, buybackDeadline, bu = '' } = this.editDealData || {};
    await this.fetchFundList();
    this.form = {
      ...this.editDealData,
      shareUnitPrice,
      bu,
      deliveryDate: deliveryDate ? moment(deliveryDate, 'YYYYMMDD') : null,
      buybackDeadline: buybackDeadline ? moment(buybackDeadline) : null,
      fundId: fund.id || null,
      dealUnitPrice: '',
      shareRatio: '',
      bookRate: bookRate ? (+bookRate).toFixed(4) : '',
      effectDate: effectDate ? moment(effectDate) : null,
      sourceId: dealId
    };
    if (fund && fund.id) {
      this.fundTypeNow = fund.type;
    }
    this.investEventTrades = this.editDealData.investEventTrades
      ? this.editDealData.investEventTrades.map(_ => {
        let eventTotalShareRatio,
          eventUnitPrice = '';

        let { eventShareNum, eventTotalShareNum } = _;
        if (eventShareNum && eventTotalShareNum) {
          eventTotalShareRatio = ((eventShareNum / eventTotalShareNum) * 100).toFixed(2) + '%';
        }
        let { eventAmount } = _;
        if (eventAmount && eventTotalShareNum) {
          eventUnitPrice = (eventAmount / eventTotalShareNum).toFixed(2);
        }
        return {
          ..._,
          eventTypeText: _.eventType === 1 ? 'IPO' : _.eventType === 3 ? '重组' : '其他',
          eventHappenDateText: dateString(_.eventHappenDate, { char: '.' }),
          eventEffectDateText: dateString(_.eventEffectDate, { char: '.' }),
          // eventClassOfShareText: this.roundMap[_.eventClassOfShareId],
          eventFundText: this.fundList.find(e => e.fundId === _.eventFundId) ? this.fundList.find(e => e.fundId === _.eventFundId).fundName : '',
          eventCurrencyText: this.currencyMap[_.eventCurrency],
          eventTotalShareRatio,
          eventUnitPrice
        };
      })
      : [];
    //@ts-ignore Type 'any[]' is not assignable to type 'never[]'
    this.filterFundList = this.fundList;
    this.fmvAdjustHistoryData = this.editDealData.fmvAdjustHistory
      ? this.editDealData.fmvAdjustHistory.map((_, index) => {
        return {
          ..._,
          // 如果时间戳是0的话展示为初始化
          updateTime: _.updateTime === '19700101080000' ? '初始化' : dateString(_.updateTime, { char: '.' }),
          thisShareUnitPrice: _.thisShareUnitPrice ? parseFloat(_.thisShareUnitPrice.toFixed(10)) : '',
          adjust: _.adjust ? parseFloat(_.adjust.toFixed(10)) : '',
          updatePeople: _.updatePeople ? _.updatePeople : ''
        };
      })
      : [];
    this.initRules();
    this.$nextTick(() => {
      this.inited = true; //避免初次赋值触发watch
    });
  }

  @Watch('form.dealType')
  typeChange(dealType) {
    if (!this.inited) {
      return;
    }
    this.initRules();
    if (dealType === 2) {
      this.form = {
        ...this.form,
        fundId: null,
        classOfShareId: null,
        amount: null,
        shareNum: null,
        dealUnitPrice: null,
        shareRatio: null,
        financingAllAmount: null
      };
    }
    if (dealType === 41) {
      this.form = {
        ...this.form,
        classOfShareId: 65,
        shareNum: null,
        dealUnitPrice: null,
        financingAllAmount: null,
        totalShareNum: null,
        preValuation: null,
        postValuation: null,
        shareUnitPrice: null,
        valuationCurrency: null,
        bookRate: null,
        shareRatio: null,
        thisShareUnitPrice: null
      };
    }
    if (dealType === 43) {
      this.form = {
        ...this.form,
        classOfShareId: 65,
        dealUnitPrice: null,
        financingAllAmount: null,
        totalShareNum: null,
        shareUnitPrice: null,
        shareRatio: null
      };
    }
  }

  @Watch('form.postValuation')
  postValuationChange(val) {
    if (!this.inited) {
      return;
    }
    this.calUnitPrice();
  }

  @Watch('form.totalShareNum')
  totalShareNumChange(val) {
    if (!this.inited) {
      return;
    }
    this.calUnitPrice();
    this.calRatio();
  }

  @Watch('form.amount')
  amountChange(val) {
    this.calDealUnitPrice();
  }

  @Watch('form.shareNum')
  shareNumChange(val) {
    this.calDealUnitPrice();
    this.calRatio();
  }

  /**
   * 监听本轮持有股比变化
   * @param newVal
   * @param oldVal
   */
  @Watch('form.shareRatio', { deep: true })
  shareRatioChange(newVal: any, oldVal: any) {
    console.log('shareRatioChange.changed from', oldVal, 'to', newVal);
    //新建交易时， 如果form.initialEquityOwnership为空或者与上一次的form.shareRatio相同，则将form.shareRatio赋值给form.initialEquityOwnership
    //编辑交易、新建切片、编辑切片时，不再随之改动
    let type = this.type;
    if (newVal && this.editType === 1 && type !== 'slice') {
      this.calInitialEquityOwnership(newVal, oldVal);
    }
    // 将this.form.initialEquityOwnership 统一保留两位小数
    let { initialEquityOwnership } = this.form;
    if (initialEquityOwnership) {
      this.form.initialEquityOwnership = (+initialEquityOwnership).toFixed(2);
    }
  }
  @Watch('form.valuationCurrency')
  valuationCurrencyChange(val) {
    this.initRules();
  }
  @Watch('form.fundId')
  fundChange(val) {
    if (!this.inited) {
      return;
    }
    let fund = this.fundList.find(_ => _.fundId === val);
    if (fund) {
      this.form.currency = fund.currency;
      this.fundTypeNow = fund.fundType;
      //this.form.bu = this.isDealChange ? this.form.bu : '';
      this.initRules();
      // fundType：0-主基金，1-专项基金，2-SPV
      // 是专项基金的话，手动填写本轮BU
    }
    this.isDealChange = false;
  }

  get priceSame() {
    let { shareUnitPrice, dealUnitPrice } = this.form;
    return !(+shareUnitPrice && +dealUnitPrice && +shareUnitPrice !== +dealUnitPrice);
  }

  async fetchDetail() {
    try {
      let { projectId, id, type } = this;
      this.$store.commit('middlePageDetail/setProjectId', projectId);
      this.$store.commit('middlePageSlice/setProjectId', projectId);
      await this.$store.dispatch('middlePageDetail/fetchDetail');
      await this.$store.dispatch('middlePageSlice/fetchSlice');

      if (type === 'detail' && id) {
        this.editDealData = this.$store.state.middlePageDetail.invest.find(_ => _.dealId === +id);
      } else if (type === 'slice' && id) {
        this.editDealData = this.$store.state.middlePageSlice.invest.find(_ => _.id === +id);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async fetchFundList() {
    try {
      let res = (await fundListCommon().then()) || {};
      this.fundList = res.data || [];
    } catch (e) {}
  }

  deliveryDateChange(val) {
    this.form.effectDate = val;
  }

  buybackDeadlineChange(val) {
    this.form.buybackDeadline = val;
  }

  calUnitPrice() {
    let { postValuation, totalShareNum } = this.form;
    if (+postValuation && +totalShareNum) {
      this.form.shareUnitPrice = '' + +(+postValuation / +totalShareNum).toFixed(10);
    }
  }

  calDealUnitPrice() {
    let { amount, shareNum } = this.form;
    if (+amount && +shareNum) {
      this.form.dealUnitPrice = (+amount / +shareNum).toFixed(2);
    }
  }

  calRatio() {
    let { totalShareNum, shareNum } = this.form;
    if (+totalShareNum && +shareNum) {
      this.form.shareRatio = ((+shareNum / +totalShareNum) * 100).toFixed(2) + '%';
    }
  }

  calInitialEquityOwnership(newVal: any, oldVal: any) {
    // 将form.shareRatio去除百分号转换为form.initialEquityOwnership
    // console.log('------calInitialEquityOwnership.newVal',newVal,'oldVal',oldVal);
    let { initialEquityOwnership } = this.form;
    let curInitialEquityOwnership = initialEquityOwnership === undefined || initialEquityOwnership === null ? '' : (+initialEquityOwnership).toFixed(2) + '%';
    // console.log('calInitialEquityOwnership.curInitialEquityOwnership',curInitialEquityOwnership);
    if (newVal) {
      if (curInitialEquityOwnership === '' || curInitialEquityOwnership === oldVal) {
        this.form.initialEquityOwnership = (+newVal.replace('%', '')).toFixed(2);
        // console.log('calInitialEquityOwnership.开始设置this.form.initialEquityOwnership=',this.form.initialEquityOwnership);
      }
    }
  }

  initRules() {
    let { dealType, currency, valuationCurrency } = this.form;
    let { fundTypeNow } = this;
    let ruleMap = {
      1: ['dealType', 'thisClassOfShareId', 'deliveryDate', 'fundId', 'classOfShareId', 'currency', 'amount', 'shareNum', 'valuationCurrency', 'effectDate'],
      11: ['dealType', 'thisClassOfShareId', 'deliveryDate', 'fundId', 'classOfShareId', 'currency', 'amount', 'shareNum', 'valuationCurrency', 'effectDate'],
      2: [
        'dealType',
        'thisClassOfShareId',
        'deliveryDate',
        'totalShareNum',
        'preValuation',
        'postValuation',
        'shareUnitPrice',
        'valuationCurrency',
        'effectDate'
      ],
      41: ['dealType', 'thisClassOfShareId', 'deliveryDate', 'fundId', 'classOfShareId', 'currency', 'amount', 'effectDate'],
      42: ['dealType', 'thisClassOfShareId', 'deliveryDate', 'fundId', 'classOfShareId', 'currency', 'amount', 'shareNum', 'valuationCurrency', 'effectDate'],
      43: ['dealType', 'thisClassOfShareId', 'deliveryDate', 'fundId', 'classOfShareId', 'currency', 'amount', 'valuationCurrency', 'effectDate'],
      5: ['dealType', 'thisClassOfShareId', 'deliveryDate', 'fundId', 'classOfShareId', 'currency', 'amount', 'shareNum', 'valuationCurrency', 'effectDate'],
      def: ['dealType']
    };
    let finalRules = (ruleMap[dealType] || ruleMap.def).reduce((prev, key) => {
      prev[key] = rules[key];
      return prev;
    }, {});
    if (dealType !== 2 && currency && valuationCurrency && currency !== valuationCurrency) {
      finalRules.bookRate = rules.bookRate;
    }
    let numKeys = ['amount', 'shareNum', 'totalShareNum', 'preValuation', 'postValuation', 'shareUnitPrice', 'bookRate', 'thisShareUnitPrice'];
    numKeys.forEach(key => {
      if (finalRules[key]) {
        finalRules[key].push({ validator: validNum, trigger: 'blur' });
      } else {
        finalRules[key] = [{ validator: validNum, trigger: 'blur' }];
      }
    });
    this.rules = finalRules;
    //@ts-ignore
    this.$refs.form && this.$refs.form.clearValidate();
  }

  handleOk() {
    //@ts-ignore
    this.$refs.form.validate(async valid => {
      if (valid) {
        let title = `该条交易数据生效时间为：${this.form.effectDate.format('YYYY-MM-DD')}`;
        let { effectDate, deliveryDate, buybackDeadline } = this.form;
        let showDateWarn = Math.abs(effectDate.diff(deliveryDate, 'days')) > 90;
        let content = h => {
          let nodeList: any[] = [];
          let dateNode = h('div', {}, '所选时间和生效时间间隔90天以上，请确认选择时间是否正确');
          let priceNode = h('div', {}, '原始交易每股单价≠估值每股单价，请确认是否仍然保存');
          if (showDateWarn) {
            nodeList.push(dateNode);
          }
          if (!this.priceSame) {
            nodeList.push(priceNode);
          }
          return h(
            'div',
            {
              attrs: {
                style: 'color: #ff4d4f'
              }
            },
            nodeList
          );
        };
        this.$confirm({
          title,
          content,
          okText: '确定',
          okType: 'danger',
          cancelText: '返回修改',
          icon: 'exclamation-circle',
          width: 600,

          onOk: () => {
            this.save();
          }
        });
      } else {
        this.$message.error('请完善表单信息');
      }
    });
  }

  formatNum(value) {
    return `${value}`.replace(/(?<!\..*)\B(?=(\d{3})+(?!\d))/g, ',');
  }

  parseNum(value) {
    return value.replace(/\$\s?|(,*)/g, '');
  }

  async save() {
    let { projectId, form, id, type } = this;
    let saveApi = type === 'slice' ? sliceDealInvest : dealInvest;
    let body = {
      ...form,
      id,
      projectId,
      manageType: 1,
      bookRate: form.bookRate ? (+form.bookRate).toFixed(4) : '',
      deliveryDate: form.deliveryDate.format('YYYYMMDD'),
      effectDate: form.effectDate.format('YYYYMMDD'),
      buybackDeadline: form.buybackDeadline ? form.buybackDeadline.format('YYYYMMDD') : null,
      adjust: form.adjust
    };
    try {
      let res = await saveApi(body);
      if (res.code === 200) {
        this.$success({
          title: '提交成功',
          content: `交易${type === 'slice' ? '切片' : ''}记录提交成功`,
          okText: '确定',
          onOk: () => {
            this.toMiddlePage();
          }
        });
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  handleCancel() {
    //@ts-ignore
    this.$refs.form.clearValidate();
    this.$confirm({
      title: '取消提醒',
      content: '编辑的内容还未保存,确定取消编辑?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.toMiddlePage();
      }
    });
  }

  handleDel() {
    this.$confirm({
      title: '删除提醒',
      content: '将会删除此条记录,确定删除?',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        this.delete();
      }
    });
  }

  async delete() {
    try {
      let { projectId, id } = this;
      let res = await dealInvest({
        projectId,
        id,
        manageType: 2
      });
      if (res.code === 200) {
        this.$message.success('删除成功');
        this.toMiddlePage();
      }
    } catch (e) {
      this.$message.error(e.message);
    }
  }

  filterFund(key) {
    //@ts-ignore Type 'any[]' is not assignable to type 'never[]'
    this.filterFundList = this.fundList.filter(_ => {
      return new RegExp(key.trim(), 'i').test(_.fundName);
    });
  }

  dealChange(val) {
    this.isDealChange = true;
    let investList = this.$store.state.middlePageDetail.invest;
    let deal = investList.find(_ => _.dealId === val);
    let { deliveryDate, fund = {}, bookRate, shareUnitPrice = '', effectDate, dealId, buybackDeadline, bu = '' } = deal;
    this.form = {
      ...deal,
      shareUnitPrice,
      bu,
      deliveryDate: deliveryDate ? moment(deliveryDate, 'YYYYMMDD') : null,
      fundId: fund.id || null,
      dealUnitPrice: '',
      shareRatio: '',
      bookRate: bookRate ? (+bookRate).toFixed(4) : '',
      effectDate: effectDate ? moment(effectDate) : null,
      buybackDeadline: buybackDeadline ? moment(buybackDeadline) : null,
      sourceId: dealId
    };
  }

  toMiddlePage() {
    localStorage.setItem('handleSubmit', new Date().getTime().toString());
    if (this.type === 'slice') {
      this.$router.push({ path: '/finance/middlePage/historySlice', query: { projectId: this.projectId + '' } });
    } else {
      this.$router.push({ path: '/finance/middlePage/detail', query: { projectId: this.projectId + '' } });
    }
  }

  dateInvalid(date) {
    if (this.type === 'slice') {
      let { sourceId } = this.form;
      let { canAuth, auditDate } = this.$store.state.middlePageSlice.detail;
      let effectDate;
      if (sourceId) {
        effectDate = this.$store.state.middlePageDetail.investEffectDateMap[sourceId];
        date = date.format('YYYYMMDD');
      } else {
        effectDate = '30000101';
      }
      let valid;
      if (canAuth) {
        valid = date < effectDate;
      } else {
        valid = date > auditDate && date < effectDate;
      }
      return !valid;
    } else {
      return false;
    }
  }
}

export default DealConfig;
